import CLIENT from "../../lib/api/client";
import ENDPOINTS from "../../lib/api/endpoints";

export const fetchCartDeliveryTypes = async (cartId) => {
  const { data } = await CLIENT.get(ENDPOINTS.DELIVERY.typesForCart(cartId));

  return data;
};
